<template>
  <div>
    <button
      v-if="!item.path"
      :data-test-id="`button-menu-grupo-${item.id}`"
      :data-target="`#${collapseId}`"
      :aria-controls="collapseId"
      class="btn btn-link btn-block"
      type="button"
      data-toggle="collapse"
      aria-expanded="false"
    >
      <span
        v-show="item.items"
        aria-hidden="true"
        class="pull-right fa fa-caret-down"
      />
      <span :data-test-id="item.descricao" class="pull-left">
        {{ item.descricao }}
      </span>
    </button>
    <RouterLink
      v-if="item.path"
      :id="item.id + '_route'"
      :data-test-id="`link-menu-item-${item.id}`"
      :to="'/' + item.path"
      :class="{ 'menu-lateral-ativo': `/${item.path}` === $route.path }"
      type="button"
    >
      {{ item.descricao }}
    </RouterLink>
    <ul v-if="item.items" :id="collapseId" class="collapse">
      <li v-for="i in item.items" :key="i.id">
        <MenuLateralItem :item="i" />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MenuLateralItem',
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  computed: {
    collapseId() {
      return `menu-lateral-${this.item.id}`
    },
  },
}
</script>

<style scoped>
.menu-lateral-ativo {
  border-right: 8px solid #008080;
}
</style>
